import isPropValid from '@emotion/is-prop-valid';
import styled from '@emotion/styled';
import SuperHeader from '@ep/components/Layout/Header/SuperHeader';
import Logo from '@ep/images/logo.svg';
import theme from '@ep/theme';
import { Link } from 'gatsby';
import React from 'react';
import ContactUs from './ContactUs';
import HamburgerButton, { HamburgerButtonProps } from './HamburgerButton';
import Info from './Info';
import SearchBar from './SearchBar';

export interface HeaderProps {
  location: WindowLocation;
  scrollingDown: boolean;
  drawerOpen: boolean;
  toggleDrawer: () => void;
}

const Headerbar = styled.header`
  position: relative;
  display: flex;
  align-items: center;
  margin: 0 auto;
  max-width: ${theme.breakpoints.optimalDesktop}px;
  padding: 0 2rem;
  height: 6rem;

  ${theme.mediaQueries.tablet} {
    height: 5.25rem;
  }

  ${theme.mediaQueries.mobile} {
    padding: 0 1rem;
    height: 3.5rem;
  }
`;

const HomeLink = styled(Link)`
  width: 15rem;
  display: flex;
  align-items: center;

  @media (max-width: ${theme.breakpoints.smallDesktop + 75}px) {
    width: 8rem;
  }

  ${theme.mediaQueries.tablet} {
    width: 12.125rem;
  }

  ${theme.mediaQueries.mobile} {
    width: 9rem;
  }

  svg {
    width: 100%;
    vertical-align: middle;
    g {
      fill: ${theme.colors.darkBlue};
    }
  }
`;

interface HiddenProps {
  hidden?: boolean;
}

const HeaderRight = styled.div<HiddenProps>`
  display: flex;
  justify-content: right;
  align-items: center;
  transition: ${theme.transitions.create(['opacity', 'visibility'])};
  opacity: ${({ hidden }) => (hidden ? 0 : 1)};
  visibility: ${({ hidden }) => (hidden ? 'hidden' : 'visible')};
`;

const HeaderLinks = styled(HeaderRight)`
  width: 100%;

  a {
    font-size: 1rem;
    font-weight: 400;
  }

  ${theme.mediaQueries.mobile} {
    display: none;
  }

  #signin {
    font-weight: 800;
  }
`;

const ContactUsWrapper = styled(HeaderRight)`
  position: absolute;
  top: 0;
  right: 2rem;
  height: 100%;

  ${theme.mediaQueries.mobile} {
    right: 1rem;
  }
`;

const ContactUsContainer = styled.div`
  display: flex;
  margin-left: 2rem;
  justify-content: flex-end;
  align-items: center;
  button {
    font-size: 1rem;
    padding: 1rem;
    height: min-content;
  }
  @media (max-width: ${theme.breakpoints.smallDesktop + 75}px) {
    margin-left: 1rem;
  }
  ${theme.mediaQueries.mobileAndTablet} {
    margin-left: 1rem;
    button {
      font-size: 0.8rem;
      padding: 0.5rem;
    }
  }
`;

const InfoWrapper = styled(HeaderRight)`
  position: absolute;
  top: 0;
  right: 2rem;
  height: 100%;

  ${theme.mediaQueries.mobile} {
    right: 1rem;
  }
`;

const StyledSearchBar = styled(SearchBar)`
  margin-left: 2rem;
`;

const StyledHamburgerButton = styled(HamburgerButton, {
  shouldForwardProp: (prop) => isPropValid(prop) && prop !== 'hidden',
})<HiddenProps & HamburgerButtonProps>`
  margin-right: -1rem;
  transition: ${theme.transitions.create(['opacity', 'visibility'])};
  opacity: ${({ hidden }) => (hidden ? 0 : 1)};
  visibility: ${({ hidden }) => (hidden ? 'hidden' : 'visible')};

  @media (min-width: ${theme.breakpoints.desktopMenuBreak + 1}px) {
    display: none;
  }
`;

const TopItems = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-end;
  a {
    font-size: 1rem;
    font-weight: 400;
    ${theme.mediaQueries.optimalDesktop} {
      padding: 0.5rem;
    }
  }

  #signin {
    font-weight: 800;
  }
`;

function Header({ scrollingDown, drawerOpen, toggleDrawer }: HeaderProps) {
  return (
    <>
      <Headerbar>
        <HomeLink to="/" aria-label="Entertainment Partners">
          <Logo style={{ height: '3rem' }} />
        </HomeLink>
        <TopItems>
          {/* <HeaderLinks
           hidden={scrollingDown}
          > */}
          <SuperHeader />
          {/* </HeaderLinks> */}
          <StyledSearchBar />
          <ContactUsContainer>
            <ContactUs />
          </ContactUsContainer>
          <StyledHamburgerButton
            // hidden={scrollingDown}
            open={drawerOpen}
            onClick={toggleDrawer}
          />
        </TopItems>
        {/* <ContactUsWrapper hidden={!scrollingDown}>
          <ContactUs />
        </ContactUsWrapper> */}
        <InfoWrapper hidden={!scrollingDown}>
          <Info />
        </InfoWrapper>
      </Headerbar>
    </>
  );
}

export default React.memo(Header);
